import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ShipmentChargesTable from "../../components/ShipmentCharges/ShipmentChargesTable";
import AddShipCharges from "../../components/ShipmentCharges/AddShipCharges";



const AddShipChargesPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Add Shipment Charges" subtitle={"Shipment Charges"} subUrl={"shipment-charges"}/>
                <AddShipCharges/>



            </MasterLayout>
        </>
    );
};

export default AddShipChargesPage;
